import React, { useState } from "react";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Funzione per chiudere il menu dopo il click su un link
  const closeMenu = () => setIsOpen(false);

  return (
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
                type="button"
                className="navbar-toggle collapsed"
                onClick={() => setIsOpen(!isOpen)}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand page-scroll" href="#page-top">
              Atlantis
            </a>
          </div>

          <div className={`collapse navbar-collapse ${isOpen ? "in" : ""}`} id="bs-example-navbar-collapse-1">
            <ul className="nav navbar-nav navbar-right">
              <li><a href="#features" className="page-scroll" onClick={closeMenu}>Funzionalità</a></li>
              <li><a href="#about" className="page-scroll" onClick={closeMenu}>Su di noi</a></li>
              <li><a href="#services" className="page-scroll" onClick={closeMenu}>Servizi</a></li>
              <li><a href="#portfolio" className="page-scroll" onClick={closeMenu}>Galleria</a></li>
              <li><a href="#testimonials" className="page-scroll" onClick={closeMenu}>Testimonianze</a></li>
              <li><a href="#team" className="page-scroll" onClick={closeMenu}>Team</a></li>
              <li><a href="#contact" className="page-scroll" onClick={closeMenu}>Contatti</a></li>
            </ul>
          </div>
        </div>
      </nav>
  );
};
